export enum PartnerTypes {
    UBISOFT = 'ubisoft'
}

export default {
    partnerTypes: PartnerTypes
};
